import React from "react";
import { AlertsTable } from "./AlertsTable";
import { AlertsPager } from "./AlertsPager";

const MAX_SHOW_ALERT_COUNT = 5;

export default function Alerts() {
    return (
        <div className="alert_list_container">
            <div className="title_area">
                <h1 className="title">
                    アラート一覧
                </h1>
            </div>
            <AlertsTable maxShowAlertCount={MAX_SHOW_ALERT_COUNT} />
            <AlertsPager maxShowAlertCount={MAX_SHOW_ALERT_COUNT} />
        </div>
    );
}
